import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import { formatTime } from '@blade/common/pages/crowd-queue-right/utils/index';
import { getTaskTargetStr } from '@blade/common/pages/alert-details/common/util';
import detailsLevel from '@blade/common/pages/alert-details/components/details-level.vue';
import moment from 'moment';
let textBox = class textBox extends Vue {
    details;
    timeFormat(time) {
        return moment(Number(time)).format('MM-DD HH:mm:ss');
    }
    formatTime = formatTime;
    get vehicle() {
        let value = [];
        Object.keys(this.details?.automobileAnnotation?.attributeProperty).map((item) => {
            if (this.details?.automobileAnnotation?.attributeProperty[item]) {
                value.push(this.details?.automobileAnnotation?.attributeProperty[item]);
            }
        });
        return value.toString();
    }
    getTextIncidentType(val) {
        const i18n = getTaskTargetStr('incidentType', 'alarmCenterI18n', val);
        return this.$t(i18n).toString();
    }
    formatDeviceName(deviceName) {
        const deviceNameArr = deviceName?.split('/') || [];
        const deviceText = deviceNameArr[deviceNameArr.length - 1];
        return deviceText;
    }
    getTaskName(val) {
        return val.taskConsist?.taskName || '-';
    }
    getAlertTime(val) {
        return this.timeFormat(val.alertTime) || '-';
    }
    getDetailsIncidentType() {
        let newText = '';
        const type = this.details.incidentType;
        const i18n = getTaskTargetStr('incidentType', 'alarmDetailI18n', type);
        const showNumArr = [
            'INCIDENT_CROWD',
            'INCIDENT_QUEUE_COUNTING',
            'INCIDENT_STRAND',
            'INCIDENT_RETROGRADE',
            'INCIDENT_INVADE',
            'INCIDENT_SOCIAL_DISTANCE',
            'INCIDENT_CONGREGATE',
            'INCIDENT_SCATTER',
        ];
        if (showNumArr.includes(type)) {
            newText = this.$t(i18n, { num: this.details.crowdAnnotation?.value }).toString();
        }
        else if (type === 'FACE_MATCH') {
            newText = this.details.faceAnnotation?.portraitName;
        }
        else if (type === 'INCIDENT_FACE_UNMATCHED') {
            newText = this.details.faceAnnotation?.libraryName;
        }
        else if (type === 'FACE_PEDESTRIAN') {
            newText = this.details.pedestrianAnnotation?.portraitName;
        }
        else if (type === 'INCIDENT_OFF_DUTY' || type === 'INCIDENT_QUEUE_TIMING') {
            newText = this.$t(i18n, { num: formatTime(this.details.crowdAnnotation.value) }).toString();
        }
        else if (type === 'INCIDENT_CROSS_LINE') {
            newText = this.formatDeviceName(this.details.deviceName);
        }
        else if (type === 'INCIDENT_UNKNOWN_OBJECT_RETENTION') {
            newText = this.$t(i18n, { num: formatTime(this.details.objectsDetectionAnnotation.value) }).toString();
        }
        else if (type === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            newText = this.details?.pedestrianAnnotation?.portraitName;
        }
        else if (type === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_UNMATCHED') {
            newText = this.details?.pedestrianAnnotation?.libraryName;
        }
        else if (type === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED') {
            newText = this.vehicle;
        }
        else if (type === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_UNMATCHED') {
            newText = this.details?.automobileAnnotation?.vehicleName;
        }
        else if (type === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED') {
            newText = this.details?.automobileAnnotation?.value;
        }
        else if (type === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_UNMATCHED') {
            newText = this.details?.automobileAnnotation?.libraryName;
        }
        else {
            newText = this.$t(i18n).toString();
        }
        return newText;
    }
};
__decorate([
    Prop()
], textBox.prototype, "details", void 0);
textBox = __decorate([
    Component({
        name: 'textBox',
        components: { detailsLevel },
        i18n: {
            messages: lang,
        },
    })
], textBox);
export default textBox;
